module.exports = __webpack_public_path__ + "static/whitegreyhat-0ff6d1c61da73e24f980eb8f60518da6.jpeg";